import { render, staticRenderFns } from "./ChatModels.vue?vue&type=template&id=60cd84fe&"
import script from "./ChatModels.vue?vue&type=script&lang=js&"
export * from "./ChatModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports